module.exports = __webpack_public_path__ + "img/delivery.3ef2c25b.svg";